import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CallCenter from "./CallCenter";

const Layout = ({ children }) => {
  return (
    <div>
      <Header />    {/* Display Header on all pages */}
      <main style={{minHeight: '60vh'}}>{children}</main>  {/* Main content of the page */}
      <Footer />    {/* Display Footer on all pages */}
      <CallCenter />
    </div>
  )
}

export default Layout